import React, { useState } from "react";
import "../css/Mensaje.css"
import { TextField, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";


export default function PideValor(props) {
    const [valor, setValor] = useState(props.valor)

    return (
        <Dialog open={props.open} fullWidth>
            <DialogTitle>Información</DialogTitle>
            <DialogContent>
                <div className="Mens-texto">
                    {props.texto}
                </div>
                <TextField
                    value={valor}
                    onChange={(event) => { setValor(event.target.value) }}
                    fullWidth
                    type="text"
                    color="coopinfa"
                />
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" color="coopinfa" onClick={() => { props.cerrar() }}>Cancelar</Button>
                <Button variant="contained" color="coopinfa" onClick={() => { props.exito(valor) }}>Ok</Button>
            </DialogActions>
        </Dialog>
    )
}